import axios from "axios";

global.key = "colorbabySalesforce";
global.accesToken = "";
global.ruta = "https://api.clientes.intexcorp.es";
//global.ruta = "http://10.0.0.209:4500";

global.user = {};

// Si la API responde 401 (JWT caducado o no válido), se cierra la sesión y se
// vuelve al login. Todos los servicios importan este fichero, así que el
// interceptor se registra una sola vez para toda la app.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");
      if (window.location.pathname !== "/login") window.location.assign("/login");
    }
    return Promise.reject(error);
  }
);
